var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    y: 0.199951,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8001 16.3454C15.0441 18.8354 17.1781 20.8794 19.6671 22.2124L21.6221 20.2564C21.8891 19.9904 22.2441 19.9014 22.5121 20.0794C23.4891 20.4344 24.5561 20.6124 25.7121 20.6124C26.2441 20.6124 26.6001 20.9684 26.6001 21.5014V24.5234C26.6001 25.0564 26.2441 25.4124 25.7111 25.4124C17.3561 25.4124 10.6001 18.6564 10.6001 10.3014C10.6001 9.76835 10.9561 9.41235 11.4891 9.41235H14.6001C15.1331 9.41235 15.4891 9.76835 15.4891 10.3014C15.4891 11.3684 15.6671 12.4344 16.0221 13.5014C16.1121 13.7684 16.0221 14.1234 15.8441 14.3904L13.8001 16.3454Z",
    fill: "#00999E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_1622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10.6001 9.41235)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.0842691635f193d515d0a184a5e9e49d.svg";